module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-list-item', {
    attrs: {
      "modifier": "longdivider"
    },
    on: {
      "click": _vm.showDetail
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('section', {
    staticClass: "destination-outline"
  }, [_c('h1', {
    staticClass: "destination-outline-title"
  }, [_vm._v(_vm._s(_vm.areaName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.restroom.name))]), _vm._v(" "), _c('v-ons-row', {
    staticClass: "destination-restroom-detail",
    attrs: {
      "vertical-align": "bottom"
    }
  }, [_c('v-ons-col', {
    class: ['destination-restroom-icon', _vm.restroom.gender],
    attrs: {
      "width": "30px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.icon
    }
  })]), _vm._v(" "), (_vm.isAvailable) ? _c('v-ons-col', {
    staticClass: "destination-restroom-status available",
    attrs: {
      "width": "1.5em"
    }
  }, [_vm._v("空")]) : _c('v-ons-col', {
    staticClass: "destination-restroom-status unavailable",
    attrs: {
      "width": "1.5em"
    }
  }, [_vm._v("満")]), _vm._v(" "), _c('v-ons-col', {
    staticClass: "destination-restroom-count"
  }, [_vm._v("\n          残り\n          " + _vm._s(Math.max(_vm.numberOfSeats - _vm.numberOfPerson, 0)) + " / " + _vm._s(_vm.numberOfSeats) + "\n        ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    staticClass: "image-thumb",
    attrs: {
      "src": _vm.image,
      "width": "130px"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00406287","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/partials/destination_outline/restroom.vue
// module id = 598
// module chunks = 0